<template>
  <div class="home">
   
    <v-row justify='center'> 
         <img alt="Vue logo" src="../assets/logo.png">
    </v-row>
   <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  }
}
</script>
